import { render, staticRenderFns } from "./LinkCopyLinkModal.vue?vue&type=template&id=c637df84&"
import script from "./LinkCopyLinkModal.vue?vue&type=script&lang=js&"
export * from "./LinkCopyLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c637df84')) {
      api.createRecord('c637df84', component.options)
    } else {
      api.reload('c637df84', component.options)
    }
    module.hot.accept("./LinkCopyLinkModal.vue?vue&type=template&id=c637df84&", function () {
      api.rerender('c637df84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/LinkCopyLinkModal.vue"
export default component.exports